import React from "react";
import { Typography } from "antd";
import { Link } from "react-router-dom";
import "./Menu.css";

const MenuPage = () => {
    const menuItems = [
        {
          category: "Beverages",
          items: [
            { name: "Tea", price: 20, veg: true },
            { name: "Masala tea", price: 30, veg: true },
            { name: "Hot Coffee", price: 50, veg: true },
            { name: "Cold coffee", price: 90, veg: true },
            { name: "Cold coffee with ice cream", price: 110, veg: true },
            { name: "Lemon tea", price: 40, veg: true },
            { name: "Butter milk", price: 40, veg: true },
            { name: "Lassi", price: 40, veg: true },
            { name: "Cold drinks", price: 30, veg: true },
            { name: "Mineral water", price: 30, veg: true },
            { name: "Black coffee", price: 40, veg: true },
          ],
        },
        {
          category: "Sandwiches",
          items: [
            { name: "Veg sandwich", price: 80, veg: true },
            { name: "Masala sandwich", price: 90, veg: true },
            { name: "Cheese sandwich", price: 90, veg: true },
            { name: "Veg cheese sandwich", price: 120, veg: true },
            { name: "Tomato sandwich", price: 70, veg: true },
          ],
        },
        {
          category: "Maggi",
          items: [
            { name: "Plain Maggi", price: 70, veg: true },
            { name: "Veg Maggi", price: 90, veg: true },
            { name: "Cheese Maggi", price: 100, veg: true },
            { name: "Veg Cheese Maggi", price: 120, veg: true },
            { name: "Tandoori Maggi", price: 120, veg: true },
            { name: "Egg Maggi", price: 140, veg: false },
          ],
        },
        {
          category: "Chinese",
          items: [
            { name: "Veg Manchurian", price: 150, veg: true },
            { name: "Paneer Chilly", price: 200, veg: true },
            { name: "Chilly Potato", price: 200, veg: true },
            { name: "Veg Chowmein", price: 120, veg: true },
          ],
        },
        {
          category: "Indian Breads",
          items: [
            { name: "Peanut Masala", price: 150, veg: true },
            { name: "Chana Masala", price: 150, veg: true },
            { name: "Crispy Corn", price: 150, veg: true },
          ],
        },
        {
          category: "Snacks",
          items: [
            { name: "Veg Pakode", price: 150, veg: true },
            { name: "Paneer Pakoda", price: 180, veg: true },
            { name: "Pav Bhaji", price: 100, veg: true },
            { name: "French Fries", price: 90, veg: true },
            { name: "Veg Salad", price: 100, veg: true },
          ],
        },
        {
          category: "Rice",
          items: [
            { name: "Plain Rice", price: 100, veg: true },
            { name: "Jeera Rice", price: 120, veg: true },
            { name: "Veg Fried Rice", price: 150, veg: true },
            { name: "Veg Biryani", price: 170, veg: true },
            { name: "Egg Rice", price: 180, veg: false },
            { name: "Chicken Fried Rice", price: 200, veg: false },
          ],
        },
        {
          category: "Main Course Veg",
          items: [
            { name: "Dal Fry", price: 120, veg: true },
            { name: "Dal Tadka", price: 140, veg: true },
            { name: "Mix Veg", price: 150, veg: true },
            { name: "Paneer Butter Masala", price: 200, veg: true },
            { name: "Mutter Paneer", price: 180, veg: true },
            { name: "Shahi Paneer", price: 160, veg: true },
            { name: "Paneer Punjabi", price: 200, veg: true },
            { name: "Sev Tamatar", price: 150, veg: true },
            { name: "Aloo Pyaaz", price: 90, veg: true },
          ],
        },
        {
          category: "Chicken Starters",
          items: [
            { name: "Chicken Dana", price: 220, veg: false },
            { name: "Chicken Bhujma", price: 250, veg: false },
            { name: "Chicken Chilly", price: 200, veg: false },
            { name: "Chicken Pakoda", price: 210, veg: false },
          ],
        },
        {
          category: "Main Course Non-Veg",
          items: [
            { name: "Chicken Curry", price: 200, veg: false },
            { name: "Chicken Bhujma", price: 200, veg: false },
            { name: "Chicken Kadai", price: 180, veg: false },
            { name: "Butter Chicken", price: 220, veg: false },
            { name: "Lemon Chicken", price: 250, veg: false },
            { name: "Desi Chicken Handi", price: 250, veg: false },
            { name: "Chicken Rajputana", price: 300, veg: false },
          ],
        },
        {
          category: "Egg Dishes",
          items: [
            { name: "Boil Eggs (2pcs)", price: 90, veg: false },
            { name: "Omelette", price: 110, veg: false },
            { name: "Egg Bhurji", price: 110, veg: false },
            { name: "Tandoori Egg Bhurji", price: 130, veg: false },
            { name: "Tandoori Egg Omelette", price: 130, veg: false },
          ],
        },
      ];

      return (
        <div className="menu-page">
          <Typography.Title level={2} style={{ color: "#752329" }}>
            Our Menu
          </Typography.Title>
          {menuItems.map((section, index) => (
            <div key={index} className="menu-section">
              <Typography.Title level={3} style={{ color: "#752329" }}>
                {section.category}
              </Typography.Title>
              {section.items.map((item, idx) => (
                <div key={idx} className="menu-item">
                  <span className="menu-item-name">{item.name}</span>
                  <span className="menu-item-price">Rs {item.price}</span>
                </div>
              ))}
            </div>
          ))}
          <Link to="/" className="back-home">
            Go Back to Home
          </Link>
        </div>
      );
    };
    
    export default MenuPage;
